export default __webpack_public_path__ + "static/5e8d493c-be01-44b9-962e-504a5cf10dd8-09ea413a48e684e80ccf5e8fdbe07a8c.woff";